<p>2025</p>
<p>A video essay on work, layoffs, salad, and never quite knowing if you want the right thing.</p>
<app-embedded-video [videoId]="videoId"></app-embedded-video>
